export default __webpack_public_path__ + "static/media/amal_alsadi.efb1a55f.jfif";